import { Box, Image, Text, TextButton } from '@wix/design-system'
import { ArrowRight, Collections, Compose, SiteMap, Template } from '@wix/wix-ui-icons-common/lazy'
import cs from 'classnames'
import React, { FC } from 'react'

import { dataHooks } from './WixStudioImageButtons.dataHooks'
import s from './WixStudioImageButtons.scss'

type Props = {
  title: string
  image: {
    src: string
    alt?: string
  }
  icon?: 'none' | 'compose' | 'collections' | 'sitemap' | 'template'
  onClick: () => void
  description: string
  dataHook?: string
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  disabled?: boolean
  arrowColor?: 'black' | 'blue'
}

export const WixStudioImageButtons: FC<Props> = props => {
  const {
    onMouseLeave,
    onMouseEnter,
    title,
    description,
    image,
    dataHook,
    onClick,
    disabled,
    arrowColor = 'black',
    icon = 'none',
  } = props

  const textSkin = disabled ? 'disabled' : 'standard'

  const hasIcon = icon !== 'none'

  return (
    <TextButton
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      dataHook={dataHook}
      onClick={onClick}
      className={s.WixStudioCreate__linkButton}
      disabled={disabled}
    >
      <Box className={s.WixStudioCreate__link} gap="12px" verticalAlign="middle">
        <ArrowRight
          className={cs(s.WixStudioCreate__arrowRight, {
            [s.disabled]: disabled,
            [s.WixStudioCreate__arrowRight_black]: arrowColor === 'black',
            [s.WixStudioCreate__arrowRight_blue]: arrowColor === 'blue',
          })}
        />
        {image.src && (
          <Image
            src={image.src}
            alt={image.alt}
            width="48px"
            height="48px"
            className={s.WixStudioCreate__linkImage}
            dataHook={dataHooks.image()}
          />
        )}
        {hasIcon && (
          <Box className={cs(s.WixStudioCreate__icon)}>
            {icon === 'compose' && <Compose />}
            {icon === 'collections' && <Collections />}
            {icon === 'sitemap' && <SiteMap />}
            {icon === 'template' && <Template />}
          </Box>
        )}
        <div>
          <Text size="medium" dataHook={dataHooks.title()} disabled={disabled} skin={textSkin}>
            {title}
          </Text>
          {description && (
            <>
              <br />
              <Text
                size="small"
                className={s.WixStudioCreate__linkDescription}
                dataHook={dataHooks.description()}
                disabled={disabled}
                skin={textSkin}
              >
                {description}
              </Text>
            </>
          )}
        </div>
      </Box>
    </TextButton>
  )
}
